var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 93,
    viewBox: "0 0 123 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m88.326 19.27 4.496 47.156-25.547-4.332L88.326 19.27ZM34.413 19.255l21.023 42.816-25.544 4.35 4.521-47.166Z",
    fill: "#FF901D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.872 60.461 61.128 14.987l-20.01 45.474L8.513 26.887l19.939 63.779a2.03 2.03 0 0 0 1.95 1.404h62.185a2.032 2.032 0 0 0 1.95-1.404l19.939-63.775-32.605 33.57Z",
    fill: "#FED130"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.117 60.462 8.514 26.886 28.453 90.66a2.029 2.029 0 0 0 1.95 1.404h15.863l-5.149-31.602Z",
    fill: "#F7BC14"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m26.42 84.162 2.031 6.497a2.029 2.029 0 0 0 1.95 1.405h62.184a2.032 2.032 0 0 0 1.95-1.404l2.03-6.498H26.42Z",
    fill: "#F7BC14"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m26.422 84.162 2.031 6.497a2.029 2.029 0 0 0 1.95 1.405h15.865l-1.287-7.9-18.559-.002Z",
    fill: "#FF901D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.495 9.874c2.813 0 5.094-2.21 5.094-4.937C66.59 2.21 64.31 0 61.495 0c-2.813 0-5.094 2.21-5.094 4.937 0 2.727 2.28 4.937 5.094 4.937Z",
    fill: "#FED130"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.043 6.966a5.024 5.024 0 0 1-3.57-1.416 5.012 5.012 0 0 1-1.524-3.522c0-.7.155-1.393.453-2.028A4.935 4.935 0 0 0 56.4 4.499a5.012 5.012 0 0 0 1.524 3.521 5.024 5.024 0 0 0 3.57 1.416 5.105 5.105 0 0 0 4.641-2.909c-.66.29-1.373.439-2.093.439Z",
    fill: "#FFB125"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.077 22.936c2.252 0 4.077-1.769 4.077-3.95 0-2.183-1.825-3.952-4.077-3.952S0 16.803 0 18.985c0 2.182 1.825 3.95 4.077 3.95Z",
    fill: "#FED130"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.113 20.522a4.02 4.02 0 0 1-3.753-2.42 4.008 4.008 0 0 1-.33-1.531c.001-.56.125-1.115.363-1.623A3.948 3.948 0 0 0 0 18.547a4.01 4.01 0 0 0 1.22 2.817 4.019 4.019 0 0 0 2.856 1.132 4.083 4.083 0 0 0 3.713-2.327 4.164 4.164 0 0 1-1.676.353Z",
    fill: "#FFB125"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M118.553 22.936c2.252 0 4.077-1.769 4.077-3.95 0-2.183-1.825-3.952-4.077-3.952s-4.077 1.769-4.077 3.951c0 2.182 1.825 3.95 4.077 3.95Z",
    fill: "#FED130"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M120.59 20.522a4.013 4.013 0 0 1-4.076-3.95c.001-.56.124-1.114.363-1.622a3.945 3.945 0 0 0-2.401 3.598 4.009 4.009 0 0 0 1.219 2.818 4.018 4.018 0 0 0 2.856 1.132 4.083 4.083 0 0 0 3.713-2.327 4.159 4.159 0 0 1-1.674.351Z",
    fill: "#FFB125"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.974 15.8c2.252 0 4.077-1.77 4.077-3.952s-1.826-3.95-4.077-3.95c-2.252 0-4.077 1.768-4.077 3.95 0 2.182 1.825 3.951 4.077 3.951ZM90.018 15.8c2.252 0 4.077-1.77 4.077-3.952s-1.825-3.95-4.077-3.95-4.077 1.768-4.077 3.95c0 2.182 1.825 3.951 4.077 3.951Z",
    fill: "#FED130"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.01 13.385a4.02 4.02 0 0 1-3.753-2.419 4.007 4.007 0 0 1-.33-1.532c0-.56.124-1.115.363-1.622a3.949 3.949 0 0 0-2.393 3.598 4.01 4.01 0 0 0 1.219 2.817 4.019 4.019 0 0 0 2.856 1.132 4.084 4.084 0 0 0 3.713-2.326 4.162 4.162 0 0 1-1.676.352ZM92.051 13.383c-2.25 0-4.076-1.054-4.076-3.236.001-.56.125-1.115.363-1.623a3.949 3.949 0 0 0-2.4 3.599 4.01 4.01 0 0 0 1.22 2.817 4.019 4.019 0 0 0 2.856 1.132 4.084 4.084 0 0 0 3.713-2.327c-.512.225-1.071-.362-1.676-.362Z",
    fill: "#FFB125"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.551353a5b89028132bff0db478fe4a5a.svg";
export { ForwardRef as ReactComponent };